import { render } from "./PaqueteProducto.vue?vue&type=template&id=aa05fb5e&scoped=true"
import script from "./PaqueteProducto.vue?vue&type=script&lang=js"
export * from "./PaqueteProducto.vue?vue&type=script&lang=js"

import "./PaqueteProducto.vue?vue&type=style&index=0&id=aa05fb5e&scoped=true&lang=scss"

import exportComponent from "C:\\laragon\\www\\framacion_front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aa05fb5e"]])

export default __exports__